module.exports = __webpack_public_path__ + "static/img/teaching_bg.ca3bf29e.png";